import styled, { css } from "styled-components";
import { Button } from "@blueprintjs/core";

export const DeleteButton = styled(({ ...props }) => <Button {...props} />)<{
  ishidden: boolean;
}>`
  margin-top: 3px;
  margin-left: 7px;
  ${(props: { ishidden: boolean }) =>
    props.ishidden &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`;
